(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["deps-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initHero(root){
      if(root.dataset.depsHeroInit) return;
      root.dataset.depsHeroInit = '1';
      var slides = Array.prototype.slice.call(root.querySelectorAll('.deps-slide'));
      if(slides.length < 2) return;
      var dotsBox = root.querySelector('[data-hero-dots]');
      var i = 0, timer = null;
      var dots = [];
      if(dotsBox){
        slides.forEach(function(_, idx){
          var b = document.createElement('button');
          if(idx===0) b.classList.add('on');
          b.addEventListener('click', function(){ go(idx); });
          dotsBox.appendChild(b);
          dots.push(b);
        });
      }
      function go(n){
        slides[i].classList.remove('on');
        if(dots[i]) dots[i].classList.remove('on');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('on');
        if(dots[i]) dots[i].classList.add('on');
      }
      var prev = root.querySelector('[data-hero-prev]');
      var next = root.querySelector('[data-hero-next]');
      if(prev) prev.addEventListener('click', function(){ go(i-1); });
      if(next) next.addEventListener('click', function(){ go(i+1); });
      function start(){
        if(root.dataset.autoplay === 'true'){
          timer = setInterval(function(){ go(i+1); }, parseInt(root.dataset.interval,10) || 5500);
        }
      }
      function stop(){ if(timer){ clearInterval(timer); timer=null; } }
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      start();
    }
    function initAll(){ document.querySelectorAll('[data-deps-hero]').forEach(initHero); }
    if(document.readyState !== 'loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deps-product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function initCar(root){
      if(root.dataset.depsCarInit) return;
      root.dataset.depsCarInit = '1';
      var scroll = root.querySelector('[data-car-scroll]');
      var prev = root.querySelector('[data-car-prev]');
      var next = root.querySelector('[data-car-next]');
      if(!scroll) return;
      function step(){
        var card = scroll.querySelector('.pcard');
        return card ? card.getBoundingClientRect().width + 20 : 300;
      }
      if(prev) prev.addEventListener('click', function(){ scroll.scrollBy({left:-step()*2, behavior:'smooth'}); });
      if(next) next.addEventListener('click', function(){ scroll.scrollBy({left:step()*2, behavior:'smooth'}); });
    }
    function initAll(){ document.querySelectorAll('[data-deps-carousel]').forEach(initCar); }
    if(document.readyState !== 'loading'){ initAll(); } else { document.addEventListener('DOMContentLoaded', initAll); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-related-prev],[data-related-next]');
    if (!btn) return;
    var wrap = btn.closest('.deps-related-wrap');
    var grid = wrap && wrap.querySelector('.product-grid');
    if (!grid) return;
    var card = grid.querySelector('.grid__item');
    var gap = parseFloat(getComputedStyle(grid).columnGap) || 16;
    var step = card ? card.getBoundingClientRect().width + gap : 300;
    grid.scrollBy({ left: btn.hasAttribute('data-related-prev') ? -step * 2 : step * 2, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
